// src/utils/constants.js

export const BLOCKED_COINS = [
  'USDC', 
  'FDUSD', 
  'DAI', 
  'TUSD', 
  'USDP', 
  'BUSD', 
  'USDT'
];